module.exports = __webpack_public_path__ + "icon_esitys.18df423eb4c629dbc93a.svg";